/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    createSlug,
    getErrorDetailsFn,
    getInputFieldProps,
    parseOnlyNumericValue,
    removeSpecialCharAndNumFn,
    safeToString,
    sliceText,
} from "../../../../utils/common";
import useAPIHandler from "../../../../hook/use-api-handler";
import { allowanceSchema } from "./allowance-validation";
import { logger, safeString } from "../../../../utils/logger";
import { ALLOWANCE_INITIAL_STATE } from "./allowance-constant";


const useAllowanceService = ({ openSnackbar }) => {
    const [allowance, setAllowance] = useState(ALLOWANCE_INITIAL_STATE);
    const [allowanceListinfo, setAllowanceListinfo] = useState([]);
    const [errors, setErrors] = useState({});

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 2,
        total: 0,
        totalPages: 1,
    });

    const { fetchData } = useAPIHandler();


    async function allowanceLists(page = 1, pageSize = 10) {
        try {
            const URL = `/admin/allowance?page=${page}&pageSize=${pageSize}`;
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                setAllowanceListinfo(result?.data?.allowances);
                setPagination({
                    page: result?.data?.pagination?.page || 1,
                    pageSize: result?.data?.pagination?.pageSize || 2,
                    total: result?.data?.pagination?.total || 0,
                    totalPages: result?.data?.pagination?.totalPages || 1,
                });
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "allowanceName") {
            value = sliceText(removeSpecialCharAndNumFn(safeToString(value)), 150)
        }
        let f;
        if(name === "allowanceType"){
            f = value;
        }
        
        if (name === "allowanceValue") {
            if(f==='percentage'){
                value = sliceText(parseOnlyNumericValue(value),3);
            }else{
                value = sliceText(parseOnlyNumericValue(value),10);
            }
        }

        setAllowance((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = allowanceSchema.extract(name);
        // const { error } = fieldSchema.validate(value);
        const { error } = fieldSchema.validate(value, {
            context: { allowanceType: allowance.allowanceType }, 
        });
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }

    }

    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = allowanceSchema.extract(name);
        // const { error } = fieldSchema.validate(value);

        const { error } = fieldSchema.validate(value, {
            context: { allowanceType: allowance.allowanceType }, 
        });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }



    const handleSubmit = async () => {
        try {
            const {
                allowanceName,
                allowanceType,
                allowanceValue,
                noWorkNoPay,
                isEsiWages,
                isEpfWages,
                status,
            } = allowance;
    
            // Validate data
            const { error } = allowanceSchema.validate(
                {
                    allowanceName,
                    allowanceType,
                    allowanceValue,
                    noWorkNoPay,
                    isEsiWages,
                    isEpfWages,
                    status,
                },
                { 
                    abortEarly: false, 
                    context: 
                        { 
                            allowanceType: allowance.allowanceType 
                        } 
                }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            // If validation errors exist, return early
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            // API request
            const response = await fetchData({
                url: "/admin/allowance",
                method: "POST",
                data: {
                    allowanceName,
                    allowanceType,
                    allowanceValue,
                    noWorkNoPay,
                    isEsiWages,
                    isEpfWages,
                    status,
                    slug: createSlug(allowanceName),
                },
            });
    
            if (response.status === "success") {
                setAllowance(ALLOWANCE_INITIAL_STATE);
                openSnackbar({
                    message: "Allowance Created Successfully",
                    color: "success",
                });
                allowanceLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    
    const handleUpdate = async (id) => {
        try {
            const {
                allowanceName,
                allowanceType,
                allowanceValue,
                noWorkNoPay,
                isEsiWages,
                isEpfWages,
                status,
            } = allowance;
    
            // Validate data
            const { error } = allowanceSchema.validate(
                {
                    allowanceName,
                    allowanceType,
                    allowanceValue,
                    noWorkNoPay,
                    isEsiWages,
                    isEpfWages,
                    status,
                },
                { 
                    abortEarly: false,
                    context: 
                        { 
                            allowanceType: allowance.allowanceType 
                        }  
                }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            // If validation errors exist, return early
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            // API request
            const response = await fetchData({
                url: `/admin/allowance/${id}`,
                method: "PUT",
                data: {
                    allowanceName,
                    allowanceType,
                    allowanceValue,
                    noWorkNoPay,
                    isEsiWages,
                    isEpfWages,
                    status,
                    slug: createSlug(allowanceName),
                },
            });
    
            if (response.status === "success") {
                setAllowance(ALLOWANCE_INITIAL_STATE);
                openSnackbar({
                    message: "Allowance Updated Successfully",
                    color: "success",
                });
                allowanceLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    
    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = {};
            error?.errors?.reduce((acc, curr) => {
                const { field, message } = curr;

                errorsAll[field] = message;

                return acc;
            });
            openSnackbar({
                message:
                    Object.keys(errorsAll).length > 0
                        ? "Validation Error!"
                        : "Something went wrong!",
                color: "danger",
            });
            setErrors(errorsAll);
        }
        else if (error?.type === "GeneralError") {
            const backendMessage = typeof error.message === "string"
                ? error.message
                : "An unexpected error occurred.";

            openSnackbar({
                message: backendMessage,
                color: "danger",
            });
        }
        logger.log(error)
    };

    //   function hanldeAddAnotherFn() {
    //     setaddAnother((prev) => !prev);
    //   }

    useEffect(() => {
        allowanceLists()
    }, []);


    return {
        allowanceListinfo,
        allowance,
        handleChange,
        handleBlurFn,
        errors,
        setAllowance,
        setErrors,
        handleSubmit,
        handleUpdate,
        pagination,
        allowanceLists
    };
};

export default useAllowanceService;